import { KeyboardEvent } from 'react';

export const handleSpaceClick = (e: KeyboardEvent<HTMLElement>) => {
  if (e.code === 'Space') {
    e.preventDefault();
    e.currentTarget.click();
  }
};
